import { useTranslation } from 'react-i18next';
import LanguageSelect from '../../../components/molecules/language-select';
import type { TelaLoginFluxoUnicoProps } from '../types';

const TelaLoginFluxoUnico = ({
	container,
	tituloEmail,
	remetenteEmail,
	destinatariosEmail,
	dataDeteccao,
	carregandoProblemaContainer,
	problemaContainer,
	formularioLoginFluxoUnico,
	erroLogin,
	carregandoLogin,
	aoAlterarInput,
	aoEntrar,
	formatarDataHora,
	formatarTemperatura,
}: TelaLoginFluxoUnicoProps) => {
	const { t } = useTranslation();

	return (
		<main className="min-h-full bg-[#f5f7fa] text-[#1f2937]">
		<header className="border-b border-[#d9e1ea] bg-white">
			<div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
				<div className="flex items-center gap-3">
					<button
						className="flex items-center gap-3 font-mono text-xl font-bold text-[#03488e] transition-colors hover:text-[#2f70f0]"
						onClick={() => window.location.assign('/container-tracking?container=')}
						type="button"
					>
						<span className="size-4 rotate-45 rounded-sm bg-[#2f70f0]" />
						Container Tracking
					</button>
				</div>
				<div className="flex items-center gap-3">
					<LanguageSelect className="w-36" />
					<div className="hidden rounded-md border border-[#d9e1ea] bg-[#f8fafc] px-4 py-2 text-sm text-[#475569] sm:block">
						{t('fluxo_unico.login.container_tracking')}
					</div>
				</div>
			</div>
		</header>

		<section className="mx-auto grid min-h-[calc(100vh-4rem)] max-w-7xl grid-cols-1 items-center gap-10 px-6 py-10 lg:grid-cols-[1fr_420px]">
			<div className="max-w-3xl">
				<div className="mb-5 flex items-center gap-3 text-sm text-[#64748b]">
					<span className="text-[#2f70f0]">{t('fluxo_unico.breadcrumb.email')}</span>
					<span>›</span>
					<span>{t('fluxo_unico.login.container_tracking')}</span>
				</div>

				<div className="mb-6 flex items-center gap-4">
					<div className="size-9 rotate-45 rounded-sm border border-[#2f70f0] bg-[#2f70f0] shadow-[0_8px_20px_rgba(47,112,240,0.2)]" />
					<div>
						<h1 className="text-3xl font-bold leading-tight tracking-normal md:text-4xl">
							{t('fluxo_unico.login.title')}
						</h1>
						<p className="mt-2 text-[#64748b]">
							{t('fluxo_unico.login.description')}
						</p>
					</div>
				</div>

				<div className="rounded-lg border border-[#d9e1ea] bg-white p-6 shadow-sm">
					<div className="mb-5 flex items-center gap-3">
						<div className="flex size-12 items-center justify-center rounded-md border border-[#ef4444] bg-[#fff1f2] text-2xl text-[#dc2626]">
							!
						</div>
						<div>
							<p className="font-mono text-sm font-bold uppercase tracking-[0.12em] text-[#64748b]">
								{t('fluxo_unico.login.informed_container')}
							</p>
							<p className="mt-1 text-2xl font-bold text-[#1f2937]">
								{container || t('fluxo_unico.login.not_informed')}
							</p>
						</div>
					</div>

					<div className="grid gap-4 border-t border-[#e2e8f0] pt-5 sm:grid-cols-3">
						<div>
							<p className="text-sm text-[#64748b]">
								{t('fluxo_unico.login.origin')}
							</p>
							<p className="mt-1 font-semibold text-[#1f2937]">
								{t('fluxo_unico.login.report_email')}
							</p>
						</div>
						<div>
							<p className="text-sm text-[#64748b]">
								{t('fluxo_unico.login.module')}
							</p>
							<p className="mt-1 font-semibold text-[#1f2937]">
								{t('fluxo_unico.login.digital_record')}
							</p>
						</div>
						<div>
							<p className="text-sm text-[#64748b]">
								Status
							</p>
							<p className="mt-1 font-semibold text-[#dc2626]">
								{t('fluxo_unico.status.waiting_login')}
							</p>
						</div>
					</div>
				</div>

				{container && (
					<div className="mt-5 rounded-lg border border-[#d9e1ea] bg-white p-6 shadow-sm">
						{carregandoProblemaContainer ? (
								<p className="font-semibold text-[#475569]">
								{t('fluxo_unico.login.loading_problem')}
							</p>
						) : problemaContainer ? (
							<>
								<div className="mb-5 flex items-center gap-3">
									<div className="flex size-12 items-center justify-center rounded-md border border-[#ef4444] bg-[#fff1f2] text-2xl text-[#dc2626]">
										!
									</div>
									<div>
										<p className="font-mono text-sm font-bold uppercase tracking-[0.12em] text-[#64748b]">
											{t('fluxo_unico.login.detected_problem')}
										</p>
										<p className="mt-1 text-base font-semibold text-[#1f2937]">
											{t('fluxo_unico.login.critical_problem_detected')}
										</p>
									</div>
								</div>

								<div className="border-t border-[#e2e8f0] pt-5">
									<p className="mb-4 text-sm text-[#475569]">
										<span className="font-semibold text-[#1f2937]">
											{t('fluxo_unico.login.observation')}
										</span>{' '}
										{problemaContainer.observation ||
											'-'}
									</p>

									<div className="grid gap-4 sm:grid-cols-2">
										<div>
										<p className="text-sm text-[#64748b]">
												Container
											</p>
										<p className="mt-1 font-semibold text-[#1f2937]">
												{
													problemaContainer
														.container.label
												}{' '}
												-{' '}
												{problemaContainer
													.container.carrier ||
													'-'}
											</p>
										</div>
										<div>
										<p className="text-sm text-[#64748b]">
												{t('fluxo_unico.login.set_point')}
											</p>
										<p className="mt-1 font-semibold text-[#1f2937]">
												{formatarTemperatura(
													problemaContainer
														.container
														.temperature
												)}
											</p>
										</div>
										<div>
										<p className="text-sm text-[#64748b]">
												{t('fluxo_unico.login.current_temperature')}
											</p>
										<p className="mt-1 font-semibold text-[#dc2626]">
												{formatarTemperatura(
													problemaContainer.temperature
												)}
											</p>
										</div>
										<div>
										<p className="text-sm text-[#64748b]">
												{t('fluxo_unico.login.detection_date_time')}
											</p>
										<p className="mt-1 font-semibold text-[#1f2937]">
												{formatarDataHora(
													problemaContainer.date
												)}
											</p>
										</div>
									</div>
								</div>
							</>
						) : (
								<p className="font-semibold text-[#475569]">
								{t('fluxo_unico.login.no_additional_info')}
							</p>
						)}
					</div>
				)}
			</div>

			<form
				className="rounded-lg border border-[#d9e1ea] bg-white p-6 shadow-[0_24px_70px_rgba(15,23,42,0.08)]"
				onSubmit={aoEntrar}
			>
				<div className="mb-6">
					<p className="font-mono text-sm font-bold uppercase tracking-[0.12em] text-[#64748b]">
						{t('fluxo_unico.login.form_title')}
					</p>
					<h2 className="mt-2 text-2xl font-bold">
						{t('fluxo_unico.login.form_subtitle')}
					</h2>
				</div>

				<label className="mb-4 block">
						<span className="mb-2 block text-sm font-medium text-[#475569]">
						E-mail
					</span>
					<input
						className="h-11 w-full rounded-md border border-[#cbd5e1] bg-white px-3 text-[#1f2937] outline-none transition-colors placeholder:text-[#94a3b8] focus:border-[#2f70f0] focus:ring-2 focus:ring-[#dbeafe]"
						name="email"
						value={
							formularioLoginFluxoUnico.email
						}
						onChange={aoAlterarInput}
						placeholder="email@exemplo.com"
						autoComplete="username"
					/>
				</label>

				<label className="mb-5 block">
						<span className="mb-2 block text-sm font-medium text-[#475569]">
						{t('fluxo_unico.login.password')}
					</span>
					<input
						className="h-11 w-full rounded-md border border-[#cbd5e1] bg-white px-3 text-[#1f2937] outline-none transition-colors placeholder:text-[#94a3b8] focus:border-[#2f70f0] focus:ring-2 focus:ring-[#dbeafe]"
						name="senha"
						type="password"
						value={formularioLoginFluxoUnico.senha}
						onChange={aoAlterarInput}
						placeholder="******"
						autoComplete="current-password"
					/>
				</label>

				{erroLogin && (
					<p className="mb-4 rounded-md border border-[#ef4444] bg-[#fff1f2] px-3 py-2 text-sm font-semibold text-[#dc2626]">
						{erroLogin === 'alert.error.login'
							? t('fluxo_unico.login.invalid_credentials')
							: erroLogin}
					</p>
				)}

				<button
					className="flex h-11 w-full items-center justify-center rounded-md border border-[#2f70f0] bg-[#2f70f0] px-4 font-semibold text-white transition-colors hover:bg-[#245dcc] disabled:cursor-not-allowed disabled:opacity-70"
					disabled={carregandoLogin}
					type="submit"
				>
					{carregandoLogin ? t('fluxo_unico.login.accessing') : t('fluxo_unico.login.access')}
				</button>

				<p className="mt-5 text-center text-sm text-[#64748b]">
					{t('fluxo_unico.login.validation_notice')}
				</p>
			</form>
		</section>
		</main>
	);
};

export default TelaLoginFluxoUnico;
